import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getCompany } from './company.selectors';

const selectAdvisorPortalConfigurations = createSelector(
  getCompany,
  ({ advisorPortalConfigurations }) => advisorPortalConfigurations,
);

const selectAdvisorPortalConfigurationsList = createSelector(
  selectAdvisorPortalConfigurations,
  ({ list }) => list,
);

export const selectAdvisorPortalConfigurationsTotalCount = createSelector(
  selectAdvisorPortalConfigurationsList,
  list => list.length,
);

export const selectFilteredAdvisorPortalConfigurations = createSelector(
  getDebouncedSearchValue,
  selectAdvisorPortalConfigurationsList,
  searchItems(config => [config.name, config.gtmId]),
);
